<template>
  <div class="share-portal-notification">
    <span v-if="isvalid">This portal was shared with you by {{ name }}.  Please keep this link confidential as anyone with it may access this information.</span>
    <span v-else>You do not have access to this portal. Please contact the patient to request access.</span>
  </div>
</template>

<script>
export default {
  props: ['name','isvalid'],
  data() {
    return {

    }
  },
  methods: {

  },
}
</script>

<style lang="scss" scoped>

</style>